var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c(_vm.headerComponent,{tag:"component",attrs:{"yy":_vm.yy},on:{"changeLanguage":_vm.changeLanguage}}),_c('router-view',{key:_vm.lanageKey}),_c('scroll-top'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }